module.exports = __webpack_public_path__ + "img/repair-5.4b6332f5.jpg";